import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SeriesDataPoint, WidgetEntryWithData, WidgetWithData } from '@models/widget/widget.model';

interface WidgetListRow {
  label: string;
  value: string;
  color: string;
  unit: string;
}

@Component({
  standalone: false,
  selector: 'app-widget-device-list',
  templateUrl: './widget-device-list.component.html',
  styleUrls: ['./widget-device-list.component.scss'],
})
export class WidgetDeviceListComponent {
  @Input({ required: true }) widget!: WidgetWithData;
  @Input() showChrome = false;
  @Input() typeLabel = '';
  @Input() sourceLabel = '';
  @Input() isEditable = false;
  @Input() canDelete = true;
  @Input() isEditMode = false;
  @Input() isMockPreview = false;
  @Input() sensorTypeLabels: string[] = [];

  @Output() edit   = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();

  private readonly defaultDecimals = 1;
  private cap(s: string): string { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

  get rows(): WidgetListRow[] {
    const entries = this.widget.entries?.length ? this.widget.entries : [];

    return entries.map((entry, index) => {
      const data = entry.data ?? [];
      const point = data.length ? data[data.length - 1] : null;
      return {
        label: this.getRowLabel(entry, index),
        value: this.formatValue(point),
        color: entry.color || '#6b7280',
        unit: entry.unit || '',
      };
    });
  }

  private getRowLabel(entry: WidgetEntryWithData, index: number): string {
    return this.cap(entry.label?.trim() || entry.fieldName?.trim() || `Elemento ${index + 1}`);
  }

  private formatValue(point: SeriesDataPoint | null): string {
    if (!point || point.value === null || point.value === undefined || point.value === '') return '--';

    const numericValue = Number(point.value);
    if (!Number.isFinite(numericValue)) return String(point.value);

    return numericValue.toFixed(this.defaultDecimals);
  }
}
